import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			marginLeft: theme.spacing(-2),
			marginRight: theme.spacing(-2),
			[theme.breakpoints.up('sm')]: {
				marginLeft: theme.spacing(-3),
				marginRight: theme.spacing(-3),
			},
		},
		gridItem: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
		title: {
			backgroundColor: theme.palette.primary.main,
			borderRadius: theme.spacing(2),
			display: 'inline-flex',
			padding: theme.spacing(0.5, 2.8),
			color: theme.palette.getContrastText(theme.palette.primary.main),
		},
		text: {
			marginBottom: theme.spacing(3.7),
			'& *': {
				textAlign: 'center',

				[theme.breakpoints.down('sm')]: {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
				},
			},
		},
		itemTitle: {
			marginBottom: theme.spacing(1),
		},
	}),
	{ name: 'Content-Content8' },
)

export default useStyles
